class TextManger {
  /**
   * @description
   * Removes non numeric digits from value
   * @param value The value to be processed
   */
  static removeNonDigits (value = '') {
    if (typeof value !== 'string') throw new Error('Value needs to be a string')
    return value.replace(/[^0-9]/g, '')
  }

  /**
   * @description
   * Inserts a char given the precision (from left to right)
   * Used with to convert whole number strings into numbers with precision
   * ex: 3444 -> 34.44 value = 3444; charToInsert = .; precision = 2;
   * @param value The value to be processed
   * @param charToInsert The precision char to be inserted
   * @param precision the precision (from left to right)
   */
  static insertCharAtPrecision (value = '', charToInsert = '.', precision = 2) {
    if (typeof value !== 'string') throw new Error('Value needs to be a string')
    if (typeof charToInsert !== 'string') throw new Error('Value needs to be a string')
    if (precision < 1) throw new Error('Precision cannot be less than 1')

    const originalString = value
    const indexToInsertAt = originalString.length - precision
    return originalString.slice(0, indexToInsertAt) + charToInsert + originalString.slice(indexToInsertAt)
  }
}

export default TextManger
